import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateMovements } from '../api/cartransferService';
import { toast } from '../utils/toasts';

/**
 * Hook para generar movimientos de cartransfers
 */
export function useGenerateMovements() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: generateMovements,
    onSuccess: (data) => {
      toast('success', 'Movimientos generados exitosamente');
      queryClient.invalidateQueries({ queryKey: ['cartransfers'] });
      return data;
    },
    onError: (error) => {
      toast('error', error?.response?.data?.message || 'Error al generar movimientos');
    },
  });
} 